import script from "./CartConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./CartConfig.vue?vue&type=script&setup=true&lang=js"

import "./CartConfig.vue?vue&type=style&index=0&id=1c79d606&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c79d606"]])

export default __exports__